module.exports = __webpack_public_path__ + "img/robot.9834d490.png";